import {
  Cloud,
  Smartphone,
  Code,
  Brain,
  Cpu,
  Lightbulb,
  Users,
  Monitor,
  Wrench,
} from "lucide-react";
import {
  AwsIcon,
  GcpIcon,
  KotlinIcon,
  PythonIcon,
  NextJsIcon,
  ReactIcon,
  VueIcon,
  DockerIcon,
  VercelIcon,
  ChatGPTIcon,
  NestIcon,
  NodeIcon,
  TypeScriptIcon,
  TailwindIcon,
  AngularIcon,
  FlutterIcon,
} from "../assets/icons";

export const cardsData = [
  {
    title: "Custom Website Design & Development",
    description:
      "Build a digital presence that stands out. We design and develop high-performing websites tailored to your brand — fast, secure, and optimized for every device — turning visitors into loyal customers.",
    icon: Code,
  },
  {
    title: "Mobile App Solutions for iOS & Android",
    description:
      "Transform your ideas into powerful mobile experiences. Our expert team creates sleek, scalable apps that engage users, drive retention, and bring your business to the fingertips of a global audience.",
    icon: Smartphone,
  },
  {
    title: "Bespoke Software Solutions",
    description:
      "We develop smart, scalable software that solves real business challenges. From custom platforms to process automation, we deliver solutions that improve efficiency and accelerate growth.",
    icon: Cpu,
  },
  {
    title: "Technology Strategy & IT Consulting",
    description:
      "Make technology work for you. Our IT experts provide strategic guidance to streamline systems, strengthen infrastructure, and future-proof your business in an ever-changing digital world.",
    icon: Cloud,
  },
  {
    title: "AI-Powered Automation & Intelligence",
    description:
      "Harness the power of AI to gain a competitive edge. We help businesses integrate intelligent automation, predictive analytics, and data-driven insights that enhance decision-making and boost performance.",
    icon: Brain,
  },
];

export const steps = [
  {
    title: "Discover What’s Possible",
    description: [
      "• Understand your goals, audience, and challenges.",
      "• Identify key opportunities for growth and innovation.",
      "• Define a clear strategy aligned with your vision.",
    ],
    Icon: Lightbulb,
  },
  {
    title: "Build With Purpose",
    description: [
      "• Transform ideas into high-performing digital products.",
      "• Focus on scalability, usability, and clean design.",
      "• Develop with precision using modern best practices.",
    ],
    Icon: Users,
  },
  {
    title: "Launch With Confidence",
    description: [
      "• Conduct end-to-end testing for flawless performance.",
      "• Optimize every detail before going live.",
      "• Ensure a seamless and stress-free deployment.",
    ],
    Icon: Monitor,
  },
  {
    title: "Evolve & Excel",
    description: [
      "• Provide continuous updates and performance tuning.",
      "• Monitor growth and adapt to changing needs.",
      "• Offer dedicated support to keep your product thriving.",
    ],
    Icon: Wrench,
  },
];

export const logos = [
  { name: "AwsIcon", src: AwsIcon },
  { name: "GcpIcon", src: GcpIcon },
  { name: "KotlinIcon", src: KotlinIcon },
  { name: "PythonIcon", src: PythonIcon },
  { name: "NextJsIcon", src: NextJsIcon },
  { name: "ReactIcon", src: ReactIcon },
  { name: "VueIcon", src: VueIcon },
  { name: "DockerIcon", src: DockerIcon },
  { name: "VercelIcon", src: VercelIcon },
  { name: "ChatGPTIcon", src: ChatGPTIcon },
  { name: "NestIcon", src: NestIcon },
  { name: "NodeIcon", src: NodeIcon },
  { name: "TypeScriptIcon", src: TypeScriptIcon },
  { name: "TailwindIcon", src: TailwindIcon },
  { name: "AngularIcon", src: AngularIcon },
  { name: "FlutterIcon", src: FlutterIcon },
];
